export default __webpack_public_path__ + "static/media/docFile.56155738.svg";